import { getGameById } from "../api/game";
import { modalWait } from "./logger";

const WAIT_NOT_STARTED_HTML = `<div class="d-flex flex-column">
	<div>El juego aún no ha empezado.</div>
	<div class="mt-2">Espera a que el moderador dé la orden</div>
	</div>`;

/**
 * El backoffice marca el juego como "activo" (Start). En demo se omite la espera.
 * @returns {{ ok: boolean, gameData: object|null }}
 */
export async function fetchGameIfPlayAllowed(gameId) {
	if (!gameId) {
		return { ok: false, gameData: null };
	}
	let res;
	try {
		res = await getGameById(gameId);
	} catch {
		return { ok: false, gameData: null };
	}
	if (res.status !== 200) {
		return { ok: false, gameData: null };
	}
	const gameData = res.data;
	if (!gameData.active && !gameData.demo) {
		try {
			await modalWait({
				html: WAIT_NOT_STARTED_HTML,
			});
		} catch (_) {
			// modal cancelado / error
		}
		return { ok: false, gameData };
	}
	return { ok: true, gameData };
}
